// extracted by mini-css-extract-plugin
export var centerText = "_7x-8";
export var container = "_7x-0";
export var doughnutContainer = "_7x-7";
export var legend = "_7x-a";
export var legendItemColorDisplay = "_7x-b";
export var legendItemLabel = "_7x-d";
export var legendItemValue = "_7x-c";
export var lg = "_7x-5";
export var maxWidth = "_7x-9";
export var md = "_7x-4";
export var responsive = "_7x-6";
export var sm = "_7x-3";
export var xs = "_7x-2";
export var xxs = "_7x-1";